// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__2k6bO","cart":"styles_cart__3nfuS"};